(() => {
  if (!/^en(?:-|$)/i.test(document.documentElement.lang)) return;

  const fixSwitcher = () => {
    const switcher = document.querySelector('.tl-switcher-container');
    const target = document.querySelector('.header__icons');
    if (!switcher || !target) return;

    if (switcher.parentElement !== target) target.appendChild(switcher);
    switcher.classList.remove('hidden');
    switcher.style.setProperty('display', 'block', 'important');
    switcher.style.setProperty('opacity', '1', 'important');
    switcher.style.setProperty('transform', 'translateY(4px)', 'important');
    switcher.style.removeProperty('position');
    switcher.style.removeProperty('top');
    switcher.style.removeProperty('right');

    const overlay = switcher.querySelector('.tl-overlay');
    if (overlay) overlay.style.setProperty('align-items', 'flex-start', 'important');
  };

  const start = () => {
    fixSwitcher();
    new MutationObserver(fixSwitcher).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', fixSwitcher);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
